const HomeTitleElement = (props) => {
  const { children } = props;
  return <h2 className={'slate-home-title'}>{children}</h2>;
};

export default HomeTitleElement;
